import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

export default function PlansFeatureItem(props) {
    return (
        <Stack direction='row' justifyContent='space-between' sx={{ width: '100%' }} spacing={1}>
            <Stack direction='row' spacing={1}>
                {props.children}
                <Typography fontWeight={500}>{props.text}</Typography>
            </Stack>
            {props.helperText ? <CloseIcon /> : null}
        </Stack>
    )
}